import EntitlementService from 'src/modules/entitlement/entitlementService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'ENTITLEMENT_VIEW';

const entitlementViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: entitlementViewActions.FIND_STARTED,
      });

      const record = await EntitlementService.find(id);

      dispatch({
        type: entitlementViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: entitlementViewActions.FIND_ERROR,
      });

      getHistory().push('/entitlement');
    }
  },
};

export default entitlementViewActions;
